import React from 'react';

const FileInput = ({value, onChange, label, labelPositionTop, error}) => {
  return (
    <div className={`field-wrapper ${labelPositionTop && 'label-on-top'}`}>
      <label className="field-label">{label}</label>
      <div className="field">
        <input type="file" value={value} onChange={onChange} />
      </div>
      {error && (
        <div style={{color: 'red'}}>{error.map((message) => message)}</div>
      )}
    </div>
  );
};

export {FileInput};
